import { BaseService } from '../../../infra/base.service'
import type { NPS } from './nps'
import type { NPSRepository } from './nps.repository'

export class NPSService extends BaseService<NPS> {
    constructor(private rep: NPSRepository) {
        super(rep)
    }

    async getPlace(address) {
        return await this.rep.getPlace(address)
    }

    async getNPSPublic(companyId: string) {
        return await this.rep.getNPSPublic(companyId)
    }

    async updateGoogle(companyId: string) {
        return await this.rep.updateGoogle(companyId)
    }
}
